import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityReference } from '../../entities/shared/entity-reference.entity';
import { PaginatedResult } from '../../entities/shared/paginated-result.entity';
import { AbstractHttpService } from '../../services/abstract-http.service';
import { StockItemBase } from './entities/stock-item-base.entity';
import { StockItem } from './entities/stock-item.entity';
import { PaginatedStockItemQuery, StockItemQuery } from './queries/stock-item.query';

@Injectable({
  providedIn: 'root',
})
export class StockItemsApi extends AbstractHttpService {
  endpoint = 'stock-items';

  create(data: StockItemBase): Observable<StockItem> {
    return this.post<StockItemBase, StockItem>(data);
  }

  findAll(query: PaginatedStockItemQuery): Observable<PaginatedResult<StockItem>> {
    return this.get<PaginatedResult<StockItem>>({ query });
  }

  findAllCompact(query?: StockItemQuery): Observable<EntityReference[]> {
    return this.get<EntityReference[]>({ path: 'compact', query });
  }

  findOne(id: number): Observable<StockItem> {
    return this.get<StockItem>({ path: id });
  }

  update(id: number, data: StockItemBase): Observable<StockItem> {
    return this.patch<StockItemBase, StockItem>(data, { path: id });
  }

  deleteOne(id: number): Observable<StockItem> {
    return this.delete<StockItem>({ path: id });
  }
}
